import { createContext, useContext, type ReactNode } from "react";

/**
 * A class name to propagate into portaled UI (dialogs, popovers, dropdowns) so
 * scope-based CSS overrides reach content rendered outside the scoped DOM
 * subtree. Portaled content escapes the `.admin-scope` ancestor in the DOM, but
 * React context still flows through portals — so the portaled component can read
 * this and re-apply the scope class to itself.
 */
const ScopeClassContext = createContext<string>("");

export function ScopeClassProvider({ value, children }: { value: string; children: ReactNode }) {
  return <ScopeClassContext.Provider value={value}>{children}</ScopeClassContext.Provider>;
}

export function useScopeClass(): string {
  return useContext(ScopeClassContext);
}
